import {
  Circle,
  Check,
  ArrowRight,
  CheckCheck,
  AlertTriangle,
  X,
  Stethoscope,
  type LucideIcon,
} from "lucide-react";

import { Badge, type BadgeProps } from "@/components/ui/badge";
import type { AppointmentStatus } from "../../../shared/types/appointment";
import { appointmentStatusLabel } from "../../../shared/format";

const ICON: Record<AppointmentStatus, LucideIcon> = {
  REQUESTED: Circle,
  CONFIRMED: Check,
  CHECKED_IN: ArrowRight,
  COMPLETED: CheckCheck,
  NO_SHOW: AlertTriangle,
  CANCELLED: X,
};

const VARIANT: Record<AppointmentStatus, BadgeProps["variant"]> = {
  REQUESTED: "muted",
  CONFIRMED: "secondary",
  CHECKED_IN: "default",
  COMPLETED: "success",
  NO_SHOW: "warning",
  CANCELLED: "destructive",
};

export function AppointmentStatusBadge({
  status,
  inExam = false,
}: {
  status: AppointmentStatus;
  /** Patient is currently being examined — overrides the CHECKED_IN label with "Đang thực hiện". */
  inExam?: boolean;
}) {
  // While an encounter is open the appointment stays CHECKED_IN, but the doctor is actively
  // examining — surface that here so the Lịch hẹn mirrors the encounter queue.
  if (inExam && status === "CHECKED_IN") {
    return (
      <Badge variant="warning" className="gap-1">
        <Stethoscope aria-hidden="true" className="h-3 w-3" />
        Đang thực hiện
      </Badge>
    );
  }

  const Icon = ICON[status];
  return (
    <Badge variant={VARIANT[status]} className="gap-1">
      <Icon aria-hidden="true" className="h-3 w-3" />
      {appointmentStatusLabel[status]}
    </Badge>
  );
}
